import orderBy from "lodash/orderBy";

import {IntermediatePart} from "../../intermediatePart";
import store from "../../../../../store";
import {getColorFilterValue} from "../../../../../misc/filtersFunctions";


export default class CrownMolding extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'crown_molding';
    this.partName = 'Crown Molding';
    this.canBeDisabled = true;
    this.layerPriority = 3;
    this.translateId = "visualizer.kitchen.cabinet.crown_molding";
    this.hasAdditionalParts = true;
  }

  sortNavigationItems(navItems) {

    const cabinetParent = this.getParent();
    if (!cabinetParent.topCabinet || !cabinetParent.topCabinet.activeFeature) {
      return navItems
    }

    const filterGroups = store.getState().filterState.filterGroups;
    const colorFilterGroup = filterGroups.find(group => group.name === "Color");
    if (!colorFilterGroup) {
      return navItems
    }

    const currentTopCabinetColor = getColorFilterValue(cabinetParent.topCabinet.activeFeature, filterGroups, colorFilterGroup);
    if (!currentTopCabinetColor) {
      return navItems
    }

    navItems = orderBy(navItems, (navItem) => {
      const colorFilterValue = getColorFilterValue(navItem.part, filterGroups, colorFilterGroup);
      if (!colorFilterValue) {
        return false
      }
      return colorFilterValue.id === currentTopCabinetColor.id
    }, ['desc'])
    return navItems
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && topCabinet.disabled && !this.disabled) {
      topCabinet.disabled = this.disabled;
      topCabinet.activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
      const topHandle = this.getParent().topHandle;
      if (topHandle) {
        topHandle.disabled = this.disabled;
      }
    }
  }

  handleClick(ignoreLocked) {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.crownMolding.activeFeature = this;
    }
    this.featureClicked();
  }

  availableFeatures(cabinetFeatures) {
    return cabinetFeatures.filter(cabinetFeature => cabinetFeature.partNumber === 1)
  }

  setLayers(layout) {
    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && (topCabinet.disabled || !topCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }
    super.setLayers(layout);
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && Number.isInteger(fromFeature.partNumber)) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);
      // if (this.partId === "right_wall") {
      //   arrayOfConditions = arrayOfConditions.filter(condition => condition.propName !== "MirrorSize");
      // }
      activeFeatureParts = this.featuresParts.filter((feature) => name1 === feature.getSplittedFeatureName()
        && feature.matchesMetaForArrayOfConditions(arrayOfConditions));
      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions();
    const cabinetParent = this.getParent();
    if (cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
      && cabinetParent.topCabinet.activeFeature.metaData["MatchingFeature"]) {
      conditions.push({
        propName: 'MatchingFeature',
        propValue: cabinetParent.topCabinet.activeFeature.metaData["MatchingFeature"]
      })
    }
    return conditions
  }

}
